<!-- access-denied.component.html -->
<div class="access-denied-container">
  <div class="content-wrapper">

    <!-- Animated SVG Illustration -->
    <div class="illustration-container">
      <svg width="300" height="300" viewBox="0 0 300 300" class="access-denied-svg">
        <!-- Background Circle -->
        <circle cx="150" cy="150" r="140" fill="#f8f9fa" stroke="#e9ecef" stroke-width="2" class="bg-circle"/>

        <!-- Shield Shape -->
        <path d="M150 40 L120 60 L120 140 Q120 160 150 180 Q180 160 180 140 L180 60 Z"
              fill="#dc3545" class="shield animate-shield"/>

        <!-- Exclamation Mark -->
        <rect x="145" y="80" width="10" height="60" rx="5" fill="white" class="exclamation-line"/>
        <circle cx="150" cy="155" r="8" fill="white" class="exclamation-dot"/>

        <!-- Floating Particles -->
        <circle cx="80" cy="100" r="4" fill="#ffc107" class="particle particle-1"/>
        <circle cx="220" cy="120" r="3" fill="#28a745" class="particle particle-2"/>
        <circle cx="90" cy="200" r="5" fill="#17a2b8" class="particle particle-3"/>
        <circle cx="210" cy="220" r="4" fill="#6f42c1" class="particle particle-4"/>

        <!-- Lock Icon -->
        <rect x="60" y="240" width="30" height="20" rx="3" fill="#6c757d" class="lock-body"/>
        <path d="M65 240 L65 230 Q65 220 75 220 Q85 220 85 230 L85 240"
              stroke="#6c757d" stroke-width="3" fill="none" class="lock-shackle"/>
      </svg>
    </div>

    <div class="text-content">
      <h1 class="error-title">Can't Access</h1>

      <p class="error-message">
        ขออภัย คุณไม่มีสิทธิ์ในการเข้าถึงหน้านี้
        <br>
        <span class="sub-message">Sorry, you don't have permission to access this page</span>
      </p>

      <div class="error-details">

        <div class="detail-item">
          <i class="icon">📧</i>
          <span>Please contract Enterprise System Department</span>
        </div>
      </div>
    </div>

    <div class="action-buttons">

      <button class="btn btn-primary" style="z-index: 9999" (click)="goBack()">
        ย้อนกลับ
      </button>

    </div>


  </div>
</div>
